export default __webpack_public_path__ + "static/media/star atlas.d9eda02b.png";